"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const file_data_service_1 = require("../commons/file-data.service");
class ProjectPickerComponent {
    constructor(fileManager) {
        this.fileManager = fileManager;
        this.projects = fileManager.projects.state;
    }
}
exports.ProjectPickerComponent = ProjectPickerComponent;
